import { render } from "./3.Parallax.vue?vue&type=template&id=e8c3d922&scoped=true"
import script from "./3.Parallax.vue?vue&type=script&lang=js"
export * from "./3.Parallax.vue?vue&type=script&lang=js"

import "./3.Parallax.vue?vue&type=style&index=0&id=e8c3d922&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c3d922"]])

export default __exports__